import { render, staticRenderFns } from "./PlanContainer.vue?vue&type=template&id=066ddea4&scoped=true"
import script from "./PlanContainer.vue?vue&type=script&lang=js"
export * from "./PlanContainer.vue?vue&type=script&lang=js"
import style0 from "./PlanContainer.vue?vue&type=style&index=0&id=066ddea4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066ddea4",
  null
  
)

export default component.exports